<div class="col-12 m-t-xl">
  <div class="carousel-demo mixed">
    <div (mouseenter)="pause()" (mouseleave)="play()" class="carousel-container">
      <div class="carousel">
        <ng-content></ng-content>
        <a
          role="button"
          aria-label="Prev"
          (keyup.enter)="prev()"
          (click)="prev()"
          [hidden]="!slides.length"
          class="left carousel-control"
          id="cta-default-739"
        >
          <span aria-hidden="true" class="glyphicon glyphicon-chevron-left"></span>
          <!-- TODO Need to pull from AEM -->
          <span class="sr-only">previous</span>
        </a>
        <a
          role="button"
          aria-label="Next"
          (keyup.enter)="next()"
          (click)="next()"
          [hidden]="!slides.length"
          class="right carousel-control"
          id="cta-default-740"
        >
          <span aria-hidden="true" class="glyphicon glyphicon-chevron-right"></span>
          <!-- TODO Need to pull from AEM -->
          <span class="sr-only">next</span>
        </a>
        <ol class="carousel-indicators" [hidden]="slides.length <= 1 || this.mulitpleItems">
          <li
            aria-label="Select"
            *ngFor="let slide of slides; let idx = index"
            [class.active]="slide.active === true"
            (click)="select(slide)"
            (keyup.enter)="select(slide)"
          >
            <span class="sr-only">
              <!-- TODO Need to pull from AEM -->
              slide {{ idx + 1 }} of {{ slides.length
              }}<!-- ngIf: isActive(slide) -->
              <span *ngIf="slide.active === true">, currently active</span
              ><!-- end ngIf: isActive(slide) -->
            </span>
          </li>
        </ol>
      </div>
    </div>
  </div>
</div>
